import styled from 'styled-components';

export const ImageSizeContainer = styled.div`
  // make images not super crazy big
  img {
    max-width: 100%;
  }
`;
